enum FuelType {
  Petrol = 'petrol',
  Diesel = 'diesel',
  Electric = 'el',
  PluginHybrid = 'pluginHybrid',
  EREV = 'erev',
  MildHybrid = 'mildHybrid',
}

export default FuelType;
